import { render, staticRenderFns } from "./TariffExceptionFormDialog.vue?vue&type=template&id=37d4047c&"
import script from "./TariffExceptionFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TariffExceptionFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports